import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import * as moment from "moment";
import { GetNewCalendarEvent } from "./GetNewCalendarEvent";

export function GetNewFreeTimeEvents(
    freeTimeStartTime: string,
    nextEventStartTime: string
) {
    const newFreeTimeEvents: ICalendarEvent[] = [];

    const freeTimeDuration = moment(nextEventStartTime).diff(
        freeTimeStartTime,
        "minute"
    );

    const shouldCreateFreeTimeEvents = freeTimeDuration >= 60;

    if (!shouldCreateFreeTimeEvents) {
        return [];
    }

    let remainingFreeTime = freeTimeDuration;
    let startTime = moment(freeTimeStartTime);

    while (remainingFreeTime >= 60) {
        const endTime = moment(startTime).add(60, "minutes");

        const freeTimeCalendarEvent = GetNewCalendarEvent(
            startTime.format(),
            endTime.format()
        );

        const isFreeTimeBlockInThePast = new CalendarEvent(
            freeTimeCalendarEvent
        ).HasFinished;

        if (!isFreeTimeBlockInThePast) {
            newFreeTimeEvents.push(freeTimeCalendarEvent);
        }

        remainingFreeTime -= 60;
        startTime = startTime.add(60, "minutes");
    }

    return newFreeTimeEvents;
}
